export default {"src":"/_next/static/media/hero-text.ab5a85fe.svg","height":463,"width":691,"blurWidth":0,"blurHeight":0};